import React from 'react';
import '../styles/SalesBanner.css'; 

const SalesBanner = () => {
  return (
    <div className="sales-banner">
      <div className="banner-content">
        <p className="banner-message">🔥 Limited Time Offer & Special Discount Available!</p>
        <a href="/shop" className="banner-button">Shop Now</a>
      </div>
    </div>
  );
};

export default SalesBanner;
